import { h, Component } from 'preact'
import { GetServerSideProps } from '../../server-middleware/context'
import { getHeaderConfiguration } from '../../services/headerWidgetInformation'

export interface Props {
  headerType: 'default' | 'ssi' | 'custom'
  headerInfo: {
    defaultHeader: {
      label: string
      labelMobile: string
      url: string
      logoUrl: string
      backgroundColor: string
      linkColor: string
    }
    ssiHeader: {
      html: string
    }
    customHeader: {
      html: string
    }
  }
  username: string
  avatar: string
  customerTitle: string
  staticPath: string
}

export const getServerSideProps: GetServerSideProps<unknown, Props> = async (context) => {
  return await getHeaderConfiguration(context)
}

export default class Header extends Component<Props> {
  render (props: Props) {
    const { headerType, headerInfo, customerTitle, staticPath } = props

    const headerClass = 'ssi ssi-header custom-header'

    if (headerType === 'ssi') return <div class={headerClass} dangerouslySetInnerHTML={{ __html: headerInfo.ssiHeader?.html || '' }} />
    if (headerType === 'custom') return <div class={headerClass} dangerouslySetInnerHTML={{ __html: headerInfo.customHeader?.html || '' }} />

    return (
      <div class={headerClass}>
        <section class='full-width Template-brand-header'>
          <div class='brand-navigation-wrapper qa-brand-navigation p-v' style={{ background: headerInfo.defaultHeader.backgroundColor }}>
            <div class='sitewidth'>
              <div class='col'>
                <div class='brand-navigation-container'>
                  <div class='brand-logo-container'>
                    <a href='/' target='_self' class='brand-logo brand--logo-anchor pull-left'>
                      <img src={headerInfo.defaultHeader.logoUrl ? headerInfo.defaultHeader.logoUrl : `${staticPath}/images/brand_logo.svg`} title='' alt={`${customerTitle} Logo`} />
                    </a>
                  </div>
                  <div class='brand-url-container'>
                    {headerInfo.defaultHeader.url && headerInfo.defaultHeader.label
                      ? <a href={headerInfo.defaultHeader.url} style={{ color: headerInfo.defaultHeader.linkColor }} class='brand-external-url link link--light pull-right is-hidden-M' target='_blank' rel='noreferrer'>
                        {headerInfo.defaultHeader.label}
                        <span class='icon icon--caret-right icon--auto-width' aria-hidden='true' />
                      </a>
                      : null}
                    {headerInfo.defaultHeader.labelMobile && headerInfo.defaultHeader.url
                      ? <a href={headerInfo.defaultHeader.url} style={{ color: headerInfo.defaultHeader.linkColor }} class='brand-external-url link link--light pull-right is-hidden-L' target='_blank' rel='noreferrer'>
                        {headerInfo.defaultHeader.labelMobile}
                        <span class='icon icon--caret-right icon--auto-width' aria-hidden='true' />
                      </a>
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
